import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  noAuth = new HttpHeaders().set('noauth', 'true');

  userService = environment.userService + '/v1';
  integrationService = environment.integrationService + '/v1';
  posUserService = environment.posUserService + '/v1';
  productService = environment.productService + '/v1';
  orderService = environment.orderService;
  imageService = environment.imageService + '/v1';

  constructor(private http: HttpClient) {}

  //Team Member
  getTeamMemberList(reqObj: any, page: any, pageSize: any): Observable<any> {
    return this.http
      .post<any>(
        this.posUserService + `/team/get?page=${page}&pageSize=${pageSize}`,
        reqObj
      )
      .pipe(catchError((err) => throwError(err)));
  }

  updateTeamMember(reqObj: any): Observable<any> {
    return this.http
      .put<any>(this.posUserService + `/team`, reqObj)
      .pipe(catchError((err) => throwError(err)));
  }

  addTeamMember(reqObj: any): Observable<any> {
    return this.http
      .post<any>(this.posUserService + `/team`, reqObj)
      .pipe(catchError((err) => throwError(err)));
  }

  deleteTeamMember(id: any): Observable<any> {
    return this.http
      .delete<any>(this.posUserService + `/team/${id}`)
      .pipe(catchError((err) => throwError(err)));
  }

  getTeamMemberById(id: any): Observable<any> {
    return this.http
      .get<any>(this.posUserService + `/team/get/${id}`)
      .pipe(catchError((err) => throwError(err)));
  }

  getCustomerByEmail(reqObj: any): Observable<any> {
    return this.http
      .post<any>(this.userService + '/user/email/login', reqObj)
      .pipe(catchError((err) => throwError(err)));
  }

  getAllModule(): Observable<any> {
    console.log('getAllModule common');
    return this.http
      .get<any>(this.userService + '/module/fetch', {
        headers: this.noAuth,
      })
      .pipe(catchError((err) => throwError(err)));
  }

  addGroup(reqObj: any): Observable<any> {
    return this.http
      .post<any>(this.userService + '/group/create', reqObj)
      .pipe(catchError((err) => throwError(err)));
  }

  updateGroup(reqObj: any): Observable<any> {
    return this.http
      .put<any>(this.userService + '/group/update', reqObj)
      .pipe(catchError((err) => throwError(err)));
  }

  getAllGroup(data: any, page: any = 1, pageSize: any = 10): Observable<any> {
    return this.http
      .post<any>(this.userService + `/group/fetch/criteria?page=${page}&pageSize=${pageSize}`, data, {
        headers: this.noAuth,
      })
      .pipe(catchError((err) => throwError(err)));
  }

  getGroupDetailsById(groupId: any): Observable<any> {
    return this.http
      .get<any>(this.userService + '/group/fetch/' + groupId)
      .pipe(catchError((err) => throwError(err)));
  }
  getGroupDetailsByName(groupName: any): Observable<any> {
    return this.http
      .post<any>(this.userService + '/group/fetch/groupName', groupName)
      .pipe(catchError((err) => throwError(err)));
  }
  getUserDetailsById(userId: any): Observable<any> {
    return this.http.get<any>(this.userService + '/user/fetch/' + userId);
  }

  addUser(reqObj: any): Observable<any> {
    return this.http
      .post<any>(this.userService + '/user/register', reqObj)
      .pipe(catchError((err) => throwError(err)));
  }
  updateUser(reqObj: any): Observable<any> {
    return this.http
      .post<any>(this.userService + '/user/update', reqObj)
      .pipe(catchError((err) => throwError(err)));
  }
  deleteUser(id: any): Observable<any> {
    return this.http
      .delete<any>(this.userService + `/user/delete/${id}`)
      .pipe(catchError((err) => throwError(err)));
  }

  getUserListCreatedBy(userId: any): Observable<any> {
    return this.http
      .get<any>(this.userService + '/user/createdBy/' + userId)
      .pipe(catchError((err) => throwError(err)));
  }

  getUserListByCriteria(data: any, page: any, pageSize: any): Observable<any> {
    return this.http
      .post<any>(
        this.userService + `/user/fetch?page=${page}&pageSize=${pageSize}`,
        data
      )
      .pipe(catchError((err) => throwError(err)));
  }

  deleteGroupById(groupId: any): Observable<any> {
    return this.http
      .delete<any>(this.userService + '/group/delete/' + groupId)
      .pipe(catchError((err) => throwError(err)));
  }

  // Product Data
  getProductList(
    productCriteria: any,
    page: any = 1,
    pageSize: any = 10
  ): Observable<any> {
    return this.http.post<any>(
      this.productService +
        `/product/fetch-product/criteria?page=${page}&pageSize=${pageSize}`,
      productCriteria
    );
  }
  getProductDetailsById(id: any): Observable<any> {
    return this.http.get<any>(this.productService + `/product/${id}`);
  }
  createProduct(data: any): Observable<any> {
    return this.http.post<any>(this.productService + '/product', data);
  }
  updateProduct(data: any): Observable<any> {
    return this.http.put<any>(
      this.productService + '/product/' + data._id,
      data
    );
  }
  deleteProduct(id: any): Observable<any> {
    return this.http.delete<any>(this.productService + '/product/' + id);
  }
  // Order
  getOrderList(orderCriteria: any, page: any, pageSize: any) {
    return this.http.post<any>(
      this.orderService + `/order/all?page=${page}&pageSize=${pageSize}`,
      orderCriteria
    );
  }
  getOrderDetailsById(id: any) {
    return this.http.get<any>(this.orderService + `/order/${id}`);
  }

  updateOrder(reqObj: any, orderId: any): Observable<any> {
    return this.http
      .put<any>(this.orderService + '/order/' + orderId, reqObj)
      .pipe(catchError((err) => throwError(err)));
  }

  // new services -

  public getCollectionList(reqObj: any): Observable<any> {
    /**
         * {
            "shopId": "",
            "searchText": "",
            "status": "ACTIVE"
            }
         */
    return this.http
      .post<any>(
        this.productService + '/collection' + '/fetch-collection',
        reqObj
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public deleteCollection(reqObj: any): Observable<any> {
    return this.http
      .delete<any>(
        this.productService +
          '/collection' +
          '/delete-collection/' +
          reqObj.collectionId
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public getCollectionById(reqObj: any): Observable<any> {
    return this.http
      .get<any>(
        this.productService +
          '/collection' +
          '/fetch-collection/' +
          reqObj.collectionId
      )
      .pipe(catchError((err) => throwError(err)));
  }

  public getShopDetails(reqObj: any): Observable<any> {
    return this.http
      .get<any>(this.userService + '/shop' + '/fetch-shop/' + reqObj.shopId)
      .pipe(catchError((err) => throwError(err)));
  }

  uploadImage(formdata: any): Observable<any> {
    return this.http.post<any>(
      this.integrationService + '/file/upload-file',
      formdata
    );
  }

  /**
   * Get warehouse people configuration from magic numbers
   */
  getWarehousePeople(): Observable<any> {
    const payload = {
      name: ["warehouse_people"]
    };
    const url = this.productService + '/magicNumbers/configs/get-config-unauth';
    console.log('🚀 Making API call to:', url);
    console.log('📤 Payload:', payload);
    
    // Use noauth header since this is an unauthenticated endpoint
    return this.http.post<any>(url, payload, {
      headers: this.noAuth
    }).pipe(
      catchError((err) => {
        console.error('❌ API Error:', err);
        console.error('❌ Error status:', err.status);
        console.error('❌ Error message:', err.message);
        return throwError(err);
      })
    );
  }
}
